export default "__VITE_ASSET__CDNAxUwn__"